import { type ForcedSubject } from "@casl/ability";

type Model<T, TName extends string> = T & ForcedSubject<TName>;
type Subjects<T extends Record<string, Record<string, unknown>>> =
  | keyof T
  | { [K in keyof T]: Model<T[K], Extract<K, string>> }[keyof T];

type StandardObjectShape = {
  org_id?: number;
  marketplace?: string;
};

export const allSubjects = [
  "Ad",
  "Product",
  "PricingPlan",
  "ProductAd",
  "Category",
  "User",
  "Org",
  "Billing",
  "Goal",
  "DSPEntity",
  "DigitalShelf",
  "Export",
  "AMCAudience",
  "AMC",
  "Tag",
] as const;

type SubjectsDefinition = Record<(typeof allSubjects)[number], StandardObjectShape>;

export type TrellisSubjectKeys = (typeof allSubjects)[number];

export type TrellisSubjects = Subjects<SubjectsDefinition>;
